/**
 * Page layout classes from docs/design/MASTER.md section 5, as constants so every template uses the same values.
 *
 *   <div className={cn(container.default, gutters, pageTop, "pb-16")}>...</div>
 */

/** The page top under the navbar and announcement strip, the same on every template: 80px, 96px from 1024px. */
export const pageTop = "pt-20 lg:pt-24";

/** Side gutters: 16px on phones, 24px from 640px, 32px from 1024px. */
export const gutters = "px-4 sm:px-6 lg:px-8";

/** Content widths: reading 768px (articles, guides, prose), default 1152px (hubs, tools), wide 1280px (big tables). */
export const container = {
  reading: "mx-auto w-full max-w-3xl",
  default: "mx-auto w-full max-w-6xl",
  wide: "mx-auto w-full max-w-7xl",
} as const;

/** Vertical rhythm between major sections: 40px on phones, 64px from 1024px, with a hairline between them. */
export const sectionY = "py-10 lg:py-16";

/** A text column that cannot push its grid track wider than the screen (the minmax(0,1fr) rule). */
export const textTrack = "min-w-0";
